// Statuts des fichiers importés sur les traitements en masse
export const STATUS_FILE_IMPORTED_STATUT_A_TRAITER = {
    id: 1,
    libelle: 'En attente de traitement',
    icon: 'spinner',
    color: 'blue',
    class: 'loading',
    system: 'info',
};
export const STATUS_FILE_IMPORTED_EN_COURS_DE_TRAITEMENT = {
    id: 2,
    libelle: 'En cours de traitement',
    icon: 'loading spinner',
    color: 'blue',
    class: '',
    system: 'info',
};
export const STATUS_FILE_IMPORTED_PARTIELLEMENT_IMPORTE = {
    id: 3,
    libelle: 'Partiellement importé',
    icon: 'exclamation circle',
    color: 'orange',
    class: '',
    system: 'warning',
};
export const STATUS_FILE_IMPORTED_IMPORTE = {
    id: 4,
    libelle: 'Importé',
    icon: 'check',
    color: 'green',
    class: '',
    system: 'success',
};
export const STATUS_FILE_IMPORTED_REFUSE = {
    id: 5,
    libelle: 'Refusé',
    icon: 'times circle outline',
    color: 'red',
    class: '',
    system: 'error',
};
export const STATUS_FILE_IMPORTED_ERREUR_TECHNIQUE = {
    id: 6,
    libelle: 'Erreur technique',
    icon: 'exclamation triangle',
    color: 'red',
    class: '',
    system: 'error',
};
export const STATUS_FILE_IMPORTED_LIST = [
    STATUS_FILE_IMPORTED_STATUT_A_TRAITER,
    STATUS_FILE_IMPORTED_EN_COURS_DE_TRAITEMENT,
    STATUS_FILE_IMPORTED_PARTIELLEMENT_IMPORTE,
    STATUS_FILE_IMPORTED_IMPORTE,
    STATUS_FILE_IMPORTED_REFUSE,
    STATUS_FILE_IMPORTED_ERREUR_TECHNIQUE,
];

export const TYPE_PIECE_JOINTE_AJOUT_ARME_EN_MASSE = { id: 28, libelle: 'Ajout arme en masse' };

export const getStatusFileImportedById = (id) =>
    STATUS_FILE_IMPORTED_LIST.find((e) => e.id === parseInt(id, 10));
